export default __webpack_public_path__ + "static/media/Footer4_black_en.bcfd683d.png";